<template>
  <main>
    <HeroSection />
    <ServicesSection />
    <PricingSection />
    <PortfolioSection />
    <AboutSection />
    <ContactSection />
    <FooterSection />
  </main>
</template>

<script setup>
import HeroSection from "../components/HeroSection.vue";
import ServicesSection from "../components/ServicesSection.vue";
import PricingSection from "../components/PricingSection.vue";
import PortfolioSection from "../components/PortfolioSection.vue";
import AboutSection from "../components/AboutSection.vue";
import ContactSection from "../components/ContactSection.vue";
import FooterSection from "../components/FooterSection.vue";
</script>
